import { getTextWidth } from 'components/common/size_helpers';
import { LABEL_FONT_SIZE } from './constants';

export function nthLabels(labels, n, callbackFn) {
  for (let i = 0; i < labels.length; i += n) {
    const current = labels[i];
    const previous = i + n >= 0 ? labels[i - n] : null;
    const next = i + n < labels.length ? labels[i + n] : null;

    callbackFn({ current, previous, next });
  }
}

const labelDims = {};
export function calculateLabelDims(value) {
  if (labelDims[value]) {
    return labelDims[value];
  }

  const { width, height } = getTextWidth(value, LABEL_FONT_SIZE);
  labelDims[value] = { textWidth: width, textHeight: height };

  return labelDims[value];
}

export function getScaleValues(scale) {
  return scale.ticks ? scale.ticks() : scale.domain();
}

export function centerScale(scale) {
  if (!scale.bandwidth) return scale;

  const bandwidth = scale.bandwidth();

  if (bandwidth === 0) return scale;

  let offset = bandwidth / 2;
  if (scale.round()) {
    offset = Math.round(offset);
  }

  return d => scale(d) + offset;
}
